export enum EntityStatus {
	live = 'live',
	draft = 'draft',
}
